import React, { useEffect, useState } from 'react';
import { Share, Plus, X } from 'lucide-react';
import { isIOSSafari, isStandalone } from '../lib/push';

const STORAGE_KEY = 'ppp_ios_home_prompt_dismissed';

export default function IOSPrompt() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isIOSSafari()) return;
    if (isStandalone()) return;
    if (localStorage.getItem(STORAGE_KEY)) return;
    const timer = setTimeout(() => setVisible(true), 2500);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  return (
    <div data-testid="ios-home-prompt" style={{ position: 'fixed', bottom: 16, left: 16, right: 16, background: 'var(--pp-surface)', border: '1px solid var(--pp-success)', padding: 16, zIndex: 9999, boxShadow: '0 -10px 30px rgba(0,0,0,0.4)' }}>
      <button onClick={dismiss} aria-label="Dismiss" style={{ position: 'absolute', top: 8, right: 8, background: 'none', border: 'none', color: 'var(--pp-text-3)', cursor: 'pointer', padding: 4 }}><X size={16} /></button>
      <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: 'var(--pp-success)', letterSpacing: '0.05em' }}>INSTALL PROFITPULSEPRO</p>
      <p style={{ margin: '6px 0 10px', fontSize: 12, color: 'var(--pp-text-2)', lineHeight: 1.5 }}>
        Add to Home Screen to receive locked-screen trade alerts on iOS.
      </p>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 11, color: 'var(--pp-text-3)' }}>
        <span>1. Tap</span>
        <Share size={14} color="var(--pp-accent)" />
        <span>in Safari</span>
        <span style={{ margin: '0 4px' }}>→</span>
        <span>2. Tap</span>
        <Plus size={14} color="var(--pp-success)" />
        <span>"Add to Home Screen"</span>
      </div>
    </div>
  );
}
